import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../../../utils/constant';
import '../admin.scss';
import SearchActivities from './forms/searchActivities';

const AdminActivities = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('common.activities')} | ${APP_NAME}`;
  }, []);

  return <SearchActivities />;
};

export default AdminActivities;
